import React, { FC } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { TspInfoProps } from '@features/payment/payment-form';
import { TspFieldType } from '@entities/tsp';
import { ICON_TCP } from '@shared/config';
import { Text } from '@shared/ui/atoms';
import { Badge } from '@shared/ui/molecules';
import { getTspBadgeByService } from '../lib/getTspBadgeByService';
const TspInfo: FC<TspInfoProps> = ({
  title,
  icon,
  isVouchers = true,
  params,
  activeService
}) => {
  const badge = getTspBadgeByService({
    showVouchersForm: isVouchers,
    tspUrl: activeService?.features?.tsp_url || ''
  });
  const bannerWeb1 = params?.find(param => param.name === TspFieldType.Banner1)?.description;
  return <TspInfoWrapper>
      <TspLogoWrapper>
        <Image src={`${ICON_TCP}${icon}`} alt="Сервис" width={154} height={154} />
      </TspLogoWrapper>
      <TitleWrapper>
        <Text family="MTSWide" size={{
        desktop: 'h5',
        mobile: 'pM'
      }} weight="black" textTransform="uppercase" as="h1">
          {title}
        </Text>
      </TitleWrapper>
      <BadgeWrapper>
        <Badge color={badge.color || 'popular_20'} iconStart={badge.icon}>
          {badge.title}
        </Badge>
      </BadgeWrapper>
      <DescriptionWrapper>
        <Text family="MTSCompact" size={{
        desktop: 'pM',
        mobile: 'pS'
      }} weight="medium" color="secondary">
          {isVouchers ? bannerWeb1 : activeService?.subline}
        </Text>
      </DescriptionWrapper>
    </TspInfoWrapper>;
};
export default TspInfo;
const TspInfoWrapper = /*#__PURE__*/styled('div')({
  name: "TspInfoWrapper",
  class: "t1dhejye",
  propsAsIs: false
});
const TspLogoWrapper = /*#__PURE__*/styled('div')({
  name: "TspLogoWrapper",
  class: "t17yf8hy",
  propsAsIs: false
});
const TitleWrapper = /*#__PURE__*/styled('div')({
  name: "TitleWrapper",
  class: "t1og6hyj",
  propsAsIs: false
});
const BadgeWrapper = /*#__PURE__*/styled('div')({
  name: "BadgeWrapper",
  class: "b12ms0w6",
  propsAsIs: false
});
const DescriptionWrapper = /*#__PURE__*/styled('div')({
  name: "DescriptionWrapper",
  class: "d1me48qm",
  propsAsIs: false
});

require("./TspInfo.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./TspInfo.tsx");